import "primeicons/primeicons.css";
import FormContainer from "../FormContainer";
import { useApiClient } from "../../../shared/customHooks";
import { FormGroup } from "../models/models";
import { useState } from "react";
import { kindergartenCheckerListTable, kindergartenCheckerOptions } from "../../../shared/tableObjects/admin/kindergartenCheckerListTable";
import type { tableOptions } from "../../../components/table/Table";
import Table from "../../../components/table/Table";

export function KindergartenSearchComponent({
  searchOn,
  searchForm,
  header,
}: {
  searchOn: "fundedKinderName" | "kindergartenNameOther";
  searchForm: FormGroup;
  header: string;
}) {
  const api = useApiClient("AdminApplication");
  const [kindergartenName, setKindergartenName] = useState<any>("");
  const [year, setYear] = useState<any>("");
  const [tableOptions, setTableOptions] = useState<tableOptions>(kindergartenCheckerOptions);

  const clearSearch = () => {
    setKindergartenName("");
    setYear("");
  };

  const handleSearch = (values: any) => {
    const newKinderName =
      values["kindergarten"].accountName === undefined && values["kindergarten"].kindergartenNameOther === undefined
        ? "0"
        : searchOn === "fundedKinderName"
          ? values["kindergarten"].accountName
          : values["kindergarten"].kindergartenNameOther;
    const newYear = values["year"] === "" ? 0 : values["year"];

    setTableOptions({
      ...tableOptions,
      filters: {
        [searchOn]: {
          searchFilter: newKinderName,
        },
        ["yearApplied"]: { searchFilter: newYear },
      },
    });
    setKindergartenName(newKinderName);
    setYear(newYear);
  };

  const deepClear = (values: any): any => {
    clearSearch();
    if (Array.isArray(values)) {
      return [];
    } else if (values !== null && typeof values === "object") {
      const cleared: Record<string, any> = {};
      for (const key in values) {
        cleared[key] = deepClear(values[key]);
      }
      return cleared;
    }
    return null;
  };

  return (
    <>
      <div className="sectionHeaderTable mb-3">
        <span>{header}</span>
      </div>
      <FormContainer
        disabled={false}
        apiClient={api}
        formBody={searchForm}
        showInternalNotes={false}
        customSubmit={handleSearch}
        customClear={deepClear}
        hideCancelButton={true}
        submitBtnTitle="Submit"
        hideClearButton={false}
        displayDirtyFormWarning={false}
      />

      {(kindergartenName != "" || year != "") && (
        <Table
          key={`${kindergartenName}-${year}`}
          apiClient={api}
          route={"kinderChecker"}
          label={""}
          columns={kindergartenCheckerListTable("applications", searchOn)}
          tableOptions={tableOptions}
        />
      )}
    </>
  );
}
